import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface StatCardProps {
    value: number | string;
    label: string;
    valueColor?: string;
    trend?: {
        direction: 'up' | 'down' | 'flat';
        value: string;
    };
}

export const StatCard: React.FC<StatCardProps> = ({ value, label, valueColor, trend }) => {
    const trendColor = trend?.direction === 'up'
        ? COLORS.green
        : trend?.direction === 'down'
            ? COLORS.red
            : COLORS.grayMedium;

    const trendSymbol = trend?.direction === 'up'
        ? '↑'
        : trend?.direction === 'down'
            ? '↓'
            : '—';

    return (
        <Box
            sx={{
                flex: 1,
                backgroundColor: COLORS.cardBg,
                borderRadius: '10px',
                border: `1px solid ${COLORS.border}`,
                padding: '14px 16px',
            }}
        >
            <Typography
                sx={{
                    fontSize: '26px',
                    fontWeight: 700,
                    lineHeight: 1.1,
                    color: valueColor || COLORS.textPrimary,
                }}
            >
                {typeof value === 'number' ? value.toLocaleString() : value}
            </Typography>
            <Typography
                sx={{
                    fontSize: '11px',
                    color: COLORS.grayDark,
                    marginTop: '2px',
                }}
            >
                {label}
            </Typography>
            {trend && (
                <Typography
                    sx={{
                        fontSize: '11px',
                        fontWeight: 600,
                        marginTop: '3px',
                        color: trendColor,
                    }}
                >
                    {trendSymbol} {trend.value}
                </Typography>
            )}
        </Box>
    );
};
